// extracted by mini-css-extract-plugin
module.exports = {"imatge":"organs_imatge__Kvjs_","textDesplegable":"organs_textDesplegable__iZatl","contingutDesplegable":"organs_contingutDesplegable__deKAH"};